import React from 'react';
import { connect } from 'react-redux';
import './Notifications.scss';

import WithRouter from '../utilities/WithRouter';
import { setCurrentCampus } from '../actions';

import icon_notifications from '../assets/icon_notifications.svg';

const Notifications = ({ showMobile }) => {
  return (
    <div className="page--notifications">
      <div className={showMobile ? 'mobile' : 'desktop'}>
        <div className="header">
          <img src={icon_notifications} alt="bell icon" width="18" height="18" />
          <h1>Notifications</h1>
        </div>

        <section className="notifications-section">
          <div className="new">
            <h4>New</h4>
            <hr />
            <table>
              <thead>
                <tr>
                  <th>Location</th>
                  {!showMobile && (
                    <>
                      <th>Source</th>
                      <th>Type</th>
                      <th>Time</th>
                    </>
                  )}
                  <th></th>
                </tr>
              </thead>

              <tbody>
                <tr>
                  <td>Building 1 - Zone 1</td>
                  {!showMobile && (
                    <>
                      <td>HVAC</td>
                      <td>Error message goes here.</td>
                      <td>08/30/24 10:45am</td>
                    </>
                  )}
                  <td>
                    <div
                      className="acknowledge-button"
                      onClick={() => console.log('this will acknowledge notification!')}
                    >
                      Acknowledge
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div className="acknowledged">
            <h4>Acknowledged</h4>
            <hr />
            <table>
              <thead>
                <tr>
                  <th>Location</th>
                  {!showMobile && (
                    <>
                      <th>Source</th>
                      <th>Type</th>
                      <th>Time</th>
                      <th>Acknowledged By</th>
                      <th>Acknowledged On</th>
                    </>
                  )}
                  <th></th>
                </tr>
              </thead>

              <tbody>
                <tr>
                  <td>Building 1 - Zone 1</td>
                  {!showMobile && (
                    <>
                      <td>HVAC</td>
                      <td>Error message goes here.</td>
                      <td>08/30/24 10:45am</td>
                      <td>User One</td>
                      <td>08/30/24 11:45am</td>
                    </>
                  )}
                </tr>
              </tbody>
            </table>
          </div>
        </section>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    currentCampusId: state.currentCampusId,
    currentBuildingId: state.currentBuildingId,
    currentZoneId: state.currentZoneId,
    currentGXId: state.currentGXId,
    currentCampusData: state.currentCampusData,
    currentUserData: state.currentUserData,
    campuses: state.campuses,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setCurrentCampus: (campusId) => {
      dispatch(setCurrentCampus(campusId));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(WithRouter(Notifications));
